<nz-form-item>
  <nz-form-label>{{ to.label }}</nz-form-label>
  <nz-form-control>
    <span>{{ to["textBefore"] }}</span>
    <nz-switch class="mx-8" [formControl]="formControl"></nz-switch>
    <span>{{ to["textAfter"] }}</span>
  </nz-form-control>
</nz-form-item>
